import React, { useCallback } from 'react';
import { isAttachmentNumberExceedLimit } from '@atlassian/jira-issue-attachments-limit';
import {
	AttachmentsError,
	AttachmentsTableSkeleton,
} from '@atlassian/jira-issue-attachments-table';
import { useIssueKey } from '@atlassian/jira-issue-context-service';
import { ATTACHMENTS_VIEW } from '@atlassian/jira-issue-shared-types';
import { useUserPreferencesValue } from '@atlassian/jira-issue-user-preference-services';
import { LIST_VIEW, STRIP_VIEW } from '../constants';
import FilmStrip from '../filmstrip-view';
import ListView from '../list-view';
import type { Props } from './types';

const Content = ({ attachmentError, refreshAttachments, isPreview, totalCount }: Props) => {
	const [value] = useUserPreferencesValue(ATTACHMENTS_VIEW);
	const issueKey = useIssueKey();

	const onErrorClick = useCallback(() => {
		refreshAttachments(issueKey);
	}, [issueKey, refreshAttachments]);

	if (attachmentError) {
		return <AttachmentsError shouldHideImage onClick={onErrorClick} />;
	}

	/**
	 * Film Strip View is from Media component. Media api and Strip View will be broken when JWT token is too long.
	 * Enforce render list view when original Strip View is broken.
	 */
	const renderMode = isAttachmentNumberExceedLimit(totalCount) ? LIST_VIEW : value;

	switch (renderMode) {
		case LIST_VIEW: {
			if (isPreview) {
				return <AttachmentsTableSkeleton totalCount={totalCount} />;
			}
			return <ListView />;
		}
		case STRIP_VIEW:
		default:
			return <FilmStrip />;
	}
};

export default Content;
